import { DefaultCommandProps } from './index';

import Base from './base';

const FloatInput = ({ value, onChange, label }: DefaultCommandProps) => {
  const handleChange = (data: string) => {
    const value = parseFloat(data);

    if (!isNaN(value) || data === '') {
      onChange(label, value);
    }
  };

  return <Base id={label} value={value} onChange={handleChange} type="number" />;
};

export default FloatInput;
